// src/pages/QuotationRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import QuotationRecordFilters from "./components/QuotationRecordFilters";
import QuotationRecordTable from "./components/QuotationRecordTable";
import { fetchQuotationRecord } from "./QuotationRecordThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const QuotationRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const { filters, list } = useSelector((state) => state.quotationRecord);

  useEffect(() => {
    dispatch(fetchQuotationRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Quotation Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4" style={{ overflowX: "hidden", width: "100%" }}>
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="quotation-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Quotation Record</Title>
            </Flex>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <QuotationRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <QuotationRecordTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Quotation Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <QuotationRecordTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default QuotationRecord;
